var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8336 9.25417L14.3946 9L14.8336 8.74583C16.1234 8.00013 16.5666 6.35119 15.8209 5.06145C15.0752 3.77171 13.4263 3.32849 12.1365 4.07419L11.6975 4.32835V3.82212C11.6975 2.33282 10.4897 1.125 9.00039 1.125C7.51109 1.125 6.30327 2.33282 6.30327 3.82212V4.32835L5.86425 4.07419C4.57451 3.32849 2.92347 3.77171 2.17987 5.06145C1.43417 6.35119 1.87739 8.00224 3.16714 8.74583L3.60615 9L3.16714 9.25417C1.87529 9.99777 1.43417 11.6488 2.17777 12.9386C2.92137 14.2283 4.57241 14.6715 5.86215 13.9258L6.30117 13.6716V14.1779C6.30117 15.6672 7.50899 16.875 8.99829 16.875C10.4876 16.875 11.6954 15.6672 11.6954 14.1779V13.6716L12.1344 13.9258C13.4242 14.6715 15.0752 14.2283 15.8188 12.9386C16.5645 11.6488 16.1213 9.99777 14.8315 9.25417H14.8336Z",
    stroke: "#191919",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1863 7.42768C9.3192 6.77425 8.08262 6.94804 7.42919 7.81517C6.77576 8.6823 6.94955 9.91888 7.81668 10.5723C8.68381 11.2257 9.92039 11.052 10.5738 10.1848C11.2272 9.31769 11.0535 8.08111 10.1863 7.42768Z",
    stroke: "#191919",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.783174aed83496bdd23163a8e712dc49.svg";
export { ForwardRef as ReactComponent };